<template>
  <div class="main">
    <section class="page-body p-0">
      <div class="row">
        <div class="order-2 order-lg-1 col-lg-5">
          <div class="content-box">
            <div>
              <h5>Resetear Contraseña </h5>
              <p class="font-md content-color">Actualiza tu nueva contraseña.</p>

              <form class="custom-form form-pill" @submit.prevent="resetPassword">
                <!-- Nueva contraseña -->
                <div class="input-box1">
                  <label for="password2">Nueva Contraseña</label>
                  <div class="icon-input">
                    <input
                      class="form-control"
                      :type="showPass1 ? 'text' : 'password'"
                      required
                      name="new-password"
                      v-model="password"
                      id="password2"
                      autocomplete="new-password"
                      spellcheck="false"
                    />
                  <img
  class="showHidePassword"
  :src="showPass1 ? 'assets/icons/svg/eye-2.svg' : 'assets/icons/svg/eye-1.svg'"
  alt="Mostrar/ocultar contraseña"
  role="button"
  tabindex="0"
  @click="showPass1 = !showPass1"
  @keydown.enter.prevent="showPass1 = !showPass1"
  @keydown.space.prevent="showPass1 = !showPass1"
  style="cursor:pointer" />
                  </div>
                </div>

                <!-- Confirmar contraseña -->
                <div class="input-box1">
                  <label for="password3">Confirmar Contraseña</label>
                  <div class="icon-input">
                    <input
                      class="form-control"
                      :type="showPass2 ? 'text' : 'password'"
                      required
                      name="confirm-password"
                      v-model="repet_password"
                      id="password3"
                      autocomplete="new-password"
                      spellcheck="false"
                    />
                    <img
                      class="showHidePassword"
                      :src="showPass2 ? 'assets/icons/svg/eye-2.svg' : 'assets/icons/svg/eye-1.svg'"
                      alt="Mostrar/ocultar contraseña"
                      role="button"
                      tabindex="0"
                      @click="showPass2 = !showPass2"
                      @keydown.enter.prevent="showPass2 = !showPass2"
                      @keydown.space.prevent="showPass2 = !showPass2"
                      style="cursor:pointer"
                    />
                  </div>
                </div>

                <button type="submit" v-if="!loading" class="btn-solid rounded-pill line-none">
                  Guardar<i class="arrow"></i>
                </button>
                <div class="loader-5 center" v-if="loading"><span></span></div>
                <a href="/" class="btn-solid rounded-pill line-none btn-outline mt-3 d-flex justify-content-center">
                  Inicio <i class="arrow"></i>
                </a>
              </form>
              <a href="/login" class="backto-link font-default content-color">Regresar Login</a>
            </div>
          </div>
        </div>
        <div class="order-1 order-lg-2 col-lg-7">
          <div class="img-box">
            <img class="bg-img" src="/assets/images/bg/bg-zd-000.jpg" alt="banner" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import myApi from '../../../plugins/axios'

export default {
  name: 'ResetPassword',
  data() {
    return {
      cookie: null,
      password: null,
      repet_password: null,
      loading: false,
      // toggles para mostrar/ocultar
      showPass1: false,
      showPass2: false,
    }
  },
  methods: {
    async resetPassword() {
      if (!this.password || !this.repet_password) {
        this.$notify({ title: "VALIDACIÓN", text: `Necesitas ingresar todos los campos.`, type: 'error' });
        return;
      }
      if (this.password !== this.repet_password) {
        this.$notify({ title: "VALIDACIÓN", text: `Las contraseñas no coinciden.`, type: 'error' });
        return;
      }

      this.loading = true;
      try {
        await myApi.post("ecommerce/reset_password/", null, {
          params: {
            email: this.cookie.email,
            reset_ticket: this.cookie.ticket,
            password: this.password,
            password_confirmation: this.repet_password
          }
        });

        this.loading = false;

        this.$notify({
          title: "CONTRASEÑA ACTUALIZADA",
          text: `Tu contraseña ha sido cambiada satisfactoriamente.`,
          type: 'success'
        });

        this.$cookies.remove("forgot_password");
        this.$cookies.remove("code_password");

        setTimeout(() => {
          this.$router.push({ name: 'Login' });
        }, 50);

      } catch (error) {
        this.loading = false;

        let errorMessage = "Ocurrió un problema en el servidor.";
        const errorData = error.response?.data;

        if (errorData) {
          if (errorData.message_text) {
            errorMessage = errorData.message_text;
          } else if (errorData.errors) {
            const errors = errorData.errors;
            errorMessage = Object.values(errors).flat().join(' ');
          }
        }

        this.$notify({ title: "Error", text: errorMessage, type: 'error' });
        console.log("Error detallado:", error.response);
      }
    }
  },
  created() {
    this.cookie = this.$cookies.get("code_password");
    if (!this.cookie) {
      this.$router.push({ name: 'ForgotPassword' });
    }
  },
}
</script>

<style scoped>
.showHidePassword {
  transition: filter 0.2s ease-in-out, opacity 0.2s ease-in-out;
}

.showHidePassword:hover,
.showHidePassword:focus {
  filter: brightness(0); 
  opacity: 0.8;
  outline: none;
}
</style>